import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import DatePicker from '../../../../../LaridaeApp/datepicker/container/DatePicker'
import { actualizarDatos } from '../actions/TablaCamionesDescargadosActions'
import TablaCamionesDescargadosView from '../components/TablaCamionesDescargadosView'

function TablaCamionesDescargados (props) {
  const { hideDatePicker = false, actualizarDatos, filtroInicial = null } = props

  useEffect(() => {
    actualizarDatos(new Date(), new Date(), filtroInicial)
  }, [actualizarDatos, filtroInicial])

  const actualizarFechas = (fechaD, fechaH) => {
    props.actualizarDatos(fechaD, fechaH)
  }
  return (
    <>
      { !hideDatePicker
        ? <>
          <div className='container-entre-fechas'>
            <DatePicker
              selectRange
              locale='es'
              disabledFuture
              onDateChange={actualizarFechas}
              titulo='Seleccione las fechas'
              value='fechas'
            />
          </div>
          <hr />
        </>
        : <></>
      }

      <TablaCamionesDescargadosView />
    </>
  )
}

const mapActionsToProps = {
  actualizarDatos
}
const withRedux = connect(null, mapActionsToProps)
export default withRedux(TablaCamionesDescargados)
